import { SOCKET_URL } from '@/lib/config';
import { createContext, useEffect, useMemo } from 'react';
import { io, Socket } from 'socket.io-client';

// Create context
export const SocketContext = createContext<Socket | null>(null);

// Provide socket to children
export default function SocketContextProvider({ children }: { children: React.ReactNode }) {
  const socket = useMemo(() => io(SOCKET_URL), []);

  useEffect(() => {
    socket.on('connect', () => {
      console.log('connected to socket');
    });

    socket.on('disconnect', () => {
      console.log('disconnected from socket');
    });

    return () => {
      socket.disconnect();
    };
  }, [socket]);

  return <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>;
}
